import { freeUserUpgradeStep } from '../utils';

export const rescuesListFoodMoverTour = {
  tourKey: 'rescues_list_food_mover',
  conditions: {
    orgTypes: ['npo'],
    userTypes: ['admin', 'staff', 'driver'],
    plans: ['foodMover'],
  },
  steps: [
    {
      title: 'tours.rescues-list-food-mover.welcome.title',
      content: 'tours.rescues-list-food-mover.welcome.content',
      placement: 'center',
    },
    {
      target: '[data-tour="rescues-table"]',
      title: 'tours.rescues-list.table.title',
      content: 'tours.rescues-list.table.content',
      placement: 'top',
    },
    freeUserUpgradeStep,
  ],
};
